import {Button, openDialog} from 'platform/components';
import {HStack, Text} from 'platform/foundation';
import {match} from 'ts-pattern';

import {EntityResourceIds} from '@dms/api/shared';
import i18n from '@dms/i18n';
import {InvalidEmailWarning, SendCustomerEmailForm, useEmailConfig} from '@dms/shared';

interface CustomerInsightsEmailActionProps {
  customerId: string;
  value: string;
}

export function CustomerInsightsEmailAction(props: CustomerInsightsEmailActionProps) {
  const {isEnabled: isEmailConfigEnabled} = useEmailConfig();

  const emailContent = match(isEmailConfigEnabled)
    .with(false, () => (
      <Text size="small" color="primary" overflowWrap="anywhere">
        {props.value}
      </Text>
    ))
    .with(true, () => (
      <Button
        type="button"
        size="small"
        variant="link"
        title={props.value}
        onClick={() =>
          openDialog(
            <SendCustomerEmailForm
              customerId={props.customerId}
              recordId={props.customerId}
              resourceId={EntityResourceIds.customer}
            />,
            {
              withAdditionalFooter: true,
              size: 'large',
              title: i18n.t('general.actions.sendEmail'),
            }
          )
        }
      />
    ))
    .exhaustive();

  return (
    <HStack spacing={1} align="center">
      {emailContent}
      <InvalidEmailWarning email={props.value} data-testid="customerInsights-email" />
    </HStack>
  );
}
